IREP.dmrsurvey = (function () {
    var activityLocaleId, activityCode, pax, homeLink, hasTaken;
    var init = function (options) {
        //focusGroupId = initOptions.focusGroupId;
        activityLocaleId = options.activityLocaleId;
        activityCode = options.activityCode;
        pax = options.pax;
        homeLink = options.homeLink;
        hasTaken = options.hasTaken;
    }

    var completedSurvey = function () {
        if (hasTaken == "True" ) {
            $(".dmrSurveyCheckbox").attr("disabled", true);
            $(".dmrAnswerOther").attr('readonly', true);
            $(".dmrSurveyBigBox").attr('readonly', true);
            $("#dmrSubmitButton").hide();
            $(".dmrThanks").show();
            $(".surveyCompleted").show();
        }
    }

    var dmrAnswers = [];
    

    $(".dmrAnswerOther").focus(function () {
        var otherBox = $(this).parent(".dmrSurveyAnswer ").parent(".dmrSurveyAnswerWrapper").find(".dmrSurveyCheckbox");
        
        if($(otherBox).is(":not(:disabled)"))
        {
            $(otherBox).prop("checked", true);
            if ($(otherBox).is(":checked")) {

                $(otherBox).parent(".dmrSurveyAnswerWrapper").parent(".dmrSurveyQuestionWrapper").find(".dmrSurveyAnswerWrapper").each(function () {

                    if ($(this).find(".dmrSurveyCheckbox").val() != $(otherBox).val()) {
                        $(this).find(".dmrSurveyCheckbox").prop("checked", false);
                    }
                });
            }
        }
    });

    $(".dmrSurveyCheckbox").change(function () {
        var par = $(this).parent(".dmrSurveyQuestionWrapper");
        var box = this;

        if ($(this).is(":checked")) {
            
            $(this).parent(".dmrSurveyAnswerWrapper").parent(".dmrSurveyQuestionWrapper").find(".dmrSurveyAnswerWrapper").each(function () {
                if($(this).find(".dmrSurveyCheckbox").val() != $(box).val() )
                {
                    $(this).find(".dmrSurveyCheckbox").prop("checked", false);
                }
            });

            $(this).parent(".dmrSurveyAnswerWrapper").parent(".dmrRankQuestionWrapper").find(".dmrSurveyAnswerWrapper").each(function () {
                if($(this).find(".dmrSurveyCheckbox").val() != $(box).val() )
                {
                    $(this).find(".dmrSurveyCheckbox").prop("checked", false);
                }
            });
        }
        //Shows and hides 2 part question for #5
        var ischecked = $(this).is(':checked');
        if($(this).attr("name") == "Hardware-specific")
        {
            
            if (ischecked)
            {
                if ($("#dmrHardwareSpecific").css("display") == "none")
                {
                    if ($("#dmrSolutionDriven").css("display") == "block")
                    {
                        $("#dmrSolutionDriven").hide();
                    }
                    $("#dmrHardwareSpecific").slideDown();
                }
            }
            else if (!ischecked)
            {
                if ($("#dmrHardwareSpecific").css("display") == "block") {
                    $("#dmrHardwareSpecific").slideUp();
                }
            }
        }
        else if ($(this).attr("name") == "Solution-driven") {

            if (ischecked) {
                if ($("#dmrSolutionDriven").css("display") == "none") {
                    if ($("#dmrHardwareSpecific").css("display") == "block") {
                        $("#dmrHardwareSpecific").hide();
                    }
                    $("#dmrSolutionDriven").slideDown();
                }
            }
            else if (!ischecked) {
                if ($("#dmrSolutionDriven").css("display") == "block") {
                    $("#dmrSolutionDriven").slideUp();
                }
            }
        }
    });

    var validateAnswers = function () {
        var count = 0;
        var answerCount = 1;
        var hiddenCount = 0;

        if (hasTaken == "True")
        {
            return false;
        }
        else
        {
            if (activityCode == "201509sur_UserSurveyDMRPoints") {
                
                $(".dmrSurveyQuestionWrapper").each(function () {
                    if (answerCount == 20) {
                        //console.log($(this).find("textarea").val());
                        if ($(this).find("textarea").val() == "") {
                            $(".error").show();
                        }
                        else {
                            count += 1;
                        }
                    }
                        //Checks to see if only one of the 2 part answers are hidden
                    else if ($(this).css("display") == "none") {
                        //console.log(1738);
                        hiddenCount += 1;
                    }
                    else {
                        $(this).find(".dmrSurveyAnswerWrapper").each(function () {
                            if ($(this).find(".dmrSurveyCheckbox").is(":checked")) {
                                //console.log($(this).find(".dmrSurveyCheckbox").val());
                                count += 1;
                            }
                        });
                    }
                    answerCount += 1;
                });
                if (count == 19 && hiddenCount == 1) {
                    return true;

                }
                else {
                    $(".error").show();
                    return false;

                }
            }
            else if (activityCode == "201509sur_UserSurveyDMR") {
                
                $(".dmrSurveyQuestionWrapper").each(function () {
                    if (answerCount == 19) {
                        //console.log($(this).find("textarea").val());
                        if ($(this).find("textarea").val() == "") {
                            $(".error").show();
                        }
                        else {
                            count += 1;
                        }
                    }
                        //Checks to see if only one of the 2 part answers are hidden
                    else if ($(this).css("display") == "none") {
                        //console.log(1738);
                        hiddenCount += 1;
                    }
                    else {
                        $(this).find(".dmrSurveyAnswerWrapper").each(function () {
                            if ($(this).find(".dmrSurveyCheckbox").is(":checked")) {
                                //console.log($(this).find(".dmrSurveyCheckbox").val());
                                count += 1;
                            }
                        });
                    }
                    answerCount += 1;
                });
                if (count == 18 && hiddenCount == 1) {
                    //console.log(count);
                    //console.log(answerCount);
                    return true;

                }
                else {
                    $(".error").show();
                    //console.log(count);
                    //console.log(answerCount);
                    return false;

                }
            }
        }
        

        
        return false;
    }

    $("#dmrSubmitButton").on("click", function () {

        $(".error").hide();
        var count = 0;
        var answerCount = 1;
        var qId, aId, aText, focusGroup;

        if(validateAnswers())
        {
            var results = [];
            if (activityCode == "201509sur_UserSurveyDMRPoints")
            {
                focusGroup = 8;
                $(".dmrSurveyQuestionWrapper").each(function () {
                    qId = $(this).attr("data-questionId");
                    if (answerCount == 20) {
                        aId = $(this).find(".dmrSurveyBigBox").attr("data-answerid");
                        aText = $(this).find(".dmrSurveyBigBox").val().trim();
                        //console.log(qId + " - " + aId + " - " + aText);
                        results.push({ questionId: qId, answerId: aId, text: aText });
                    }
                        //Sets hidden answer to N/A for 2 part question
                    else if ($(this).css("display") == "none")
                    {
                        qId = $(this).attr("data-questionId");

                        $(this).find(".dmrSurveyAnswerWrapperNA").each(function () {

                            aId = $(this).find(".dmrSurveyCheckbox").attr("data-answerid")
                            aText = $(this).find(".dmrSurveyCheckbox").val().trim();
                        });

                        //console.log(qId + " - " + aId + " - " + aText);
                        results.push({ questionId: qId, answerId: aId, text: aText });
                    }
                    else {
                        $(this).find(".dmrSurveyAnswerWrapper").each(function () {
                            
                            if ($(this).find(".dmrSurveyCheckbox").is(":checked")) {
                                aId = $(this).find(".dmrSurveyCheckbox").attr("data-answerid")
                                
                                if ($(this).find(".dmrSurveyCheckbox").val() == "textbox")
                                {
                                    aText = $(this).find(".dmrSurveyAnswer").find(".dmrAnswerOther").val().trim();
                                    //console.log(qId + " - " + aId + " - " + aText);
                                    results.push({ questionId: qId, answerId: aId, text: aText });
                                }
                                else
                                {
                                    aText = $(this).find(".dmrSurveyCheckbox").val().trim();
                                    //console.log(qId + " - " + aId + " - " + aText);
                                    results.push({ questionId: qId, answerId: aId, text: aText });
                                }
                            }
                        });
                    }
                    answerCount += 1;
                });
            }
            else if (activityCode == "201509sur_UserSurveyDMR") {

                focusGroup = 9;
                $(".dmrSurveyQuestionWrapper").each(function () {
                    qId = $(this).attr("data-questionId");
                    if (answerCount == 19) {
                        aId = $(this).find(".dmrSurveyBigBox").attr("data-answerid");
                        aText = $(this).find(".dmrSurveyBigBox").val().trim();
                        //console.log(qId + " - " + aId + " - " + aText);
                        results.push({ questionId: qId, answerId: aId, text: aText });
                    }
                        //Sets hidden answer to N/A for 2 part question
                    else if ($(this).css("display") == "none") {
                        qId = $(this).attr("data-questionId");

                        $(this).find(".dmrSurveyAnswerWrapperNA").each(function () {

                            aId = $(this).find(".dmrSurveyCheckbox").attr("data-answerid")
                            aText = $(this).find(".dmrSurveyCheckbox").val().trim();
                        });

                        //console.log(qId + " - " + aId + " - " + aText);
                        results.push({ questionId: qId, answerId: aId, text: aText });
                    }
                    else {
                        $(this).find(".dmrSurveyAnswerWrapper").each(function () {

                            if ($(this).find(".dmrSurveyCheckbox").is(":checked")) {
                                aId = $(this).find(".dmrSurveyCheckbox").attr("data-answerid")

                                if ($(this).find(".dmrSurveyCheckbox").val() == "textbox") {
                                    aText = $(this).find(".dmrSurveyAnswer").find(".dmrAnswerOther").val().trim();
                                    //console.log(qId + " - " + aId + " - " + aText);
                                    results.push({ questionId: qId, answerId: aId, text: aText });
                                }
                                else {
                                    aText = $(this).find(".dmrSurveyCheckbox").val().trim();
                                    //console.log(qId + " - " + aId + " - " + aText);
                                    results.push({ questionId: qId, answerId: aId, text: aText });
                                }
                            }
                        });
                    }
                    answerCount += 1;
                });
            }

            //var results = [];
            //$(".selected").each(function () {
            //    //console.log($(this).attr('data-questionId'),$(this).attr('id'), $(this));
            //    results.push({ questionId: $(this).attr('data-questionId'), answerId: $(this).attr('id') });
            //});

            //results.push({ questionId: $("#questionSix").attr('data-questionId'), answerId: $("#questionSix").attr('data-answerId'), text: $("#questionSix").val() });

            //var data = {
            //    focusGroupId: focusGroupId,
            //    
            //};
            ////console.log(data);
            //IREP.callApi({ url: "/promotion/FocusGroup/Submit", data: data, type: "POST" }).done(function(data) {
            //    window.location.reload(true);
            //});

            var data = {
                focusGroupId: focusGroup,
                quizData: {
                    activityUID: $(this).attr('data-activityUID'),
                    results: results
                }
                
            };
            //console.log(data);
            IREP.callApi({ url: "/promotion/FocusGroup/Submit", data: data, type: "POST" }).done(function (data) {
                $("#dmrSubmitButton").css("display", "none");
                $(".dmrThanks").show();
                window.location.replace(homeLink);
            });
        }

        
    //    return false;
    });

    return {
        init: init,
        completedSurvey: completedSurvey
    };
})();